import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Flex } from 'foundations-components/components/Flex';
import { Select } from 'foundations-components/components/Select';
import _capitalize from 'hs-lodash/capitalize';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { DEBOUNCE_TIME } from '../../../constants/Http';
import { ASSOCIATION_OBJECT_PROPERTIES, CARDINALITY_TYPES } from '../../../constants/associations';
import { singularTypeToPlural } from '../../../constants/types';
import { AssociationModalPropsContext } from '../../../contexts/associationModal/PropsContext';
import { AssociationModalContext } from '../../../contexts/associationModal/context';
import captureException from '../../../utils/captureException';
import { getAssociationPropertyOptionTexts } from '../../../utils/helpers';
import CardinalityIcon from '../CardinalityIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationProperty({
  property,
  trackSelectOpen
}) {
  const {
    apiWrapper
  } = useContext(AssociationModalPropsContext);
  const {
    associationModalActions
  } = useContext(AssociationModalContext);
  const [associationCandidates, setAssociationCandidates] = useState([]);
  const [isError, setIsError] = useState(false);
  const propertyObjectType = useMemo(() => singularTypeToPlural[(property.definition.toObjectType || '').toLowerCase()], [property]);
  const loadOptions = useCallback(({
    input,
    callback
  }) => {
    apiWrapper.searchObject({
      objectType: property.definition.toObjectTypeId,
      query: input,
      limit: 50,
      properties: ASSOCIATION_OBJECT_PROPERTIES[propertyObjectType]
    }, DEBOUNCE_TIME).then(response => {
      const options = [...response.results.map(item => Object.assign({}, getAssociationPropertyOptionTexts({
        crmObject: item,
        toObjectType: property.definition.toObjectType || ''
      }), {
        value: item.id
      }))];
      callback({
        options
      });
    }).catch(error => {
      callback({
        options: []
      });
      captureException(error);
    });
  }, [property, propertyObjectType, apiWrapper]);
  const title = useMemo(() => {
    return _capitalize(property.definition.toObjectType || '');
  }, [property]);
  useEffect(() => {
    const associationTypeId = property.identifier.split('-').pop();
    if (associationTypeId) {
      associationModalActions.setCrmObjectAssociations({
        associationTypeId,
        associationsIds: Array.isArray(associationCandidates) ? associationCandidates : [associationCandidates]
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [associationCandidates]);
  useEffect(() => {
    const {
      cardinality,
      maxToObjectIds
    } = property.definition;
    setIsError(cardinality === CARDINALITY_TYPES.ONE_TO_MANY && associationCandidates.length > maxToObjectIds);
  }, [associationCandidates, property]);
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    align: "stretch",
    marginBlockStart: "400",
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [title, /*#__PURE__*/_jsx(CardinalityIcon, {
          cardinality: property.definition.cardinality
        })]
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      error: isError,
      validationMessage: isError ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.tabs.create.validation.maxAssociationAmount"
      }) : null,
      "aria-label": property.type,
      children: /*#__PURE__*/_jsx(Select, {
        multi: property.definition.cardinality === CARDINALITY_TYPES.ONE_TO_MANY,
        selectedItemsPlaceholder: I18n.text('associationModals.search.searchPlaceholder', {
          objectType: propertyObjectType
        }),
        onOpenChange: trackSelectOpen,
        loadAsyncOptions: loadOptions,
        onSelectedOptionChange: ({
          selectedValues
        }) => {
          setAssociationCandidates(selectedValues);
        },
        searchable: true
      })
    })]
  });
}
export default AssociationProperty;